import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private storage: Storage, private http: HttpClient) {}

  @Output() setPageTitle: EventEmitter<string> = new EventEmitter();
  @Output() userLogged: EventEmitter<boolean> = new EventEmitter();

  setUserLogged(flag: boolean): void {
    this.userLogged.emit(flag);
  }

  clearSession(): void {
    this.storage.clear();
    this.userLogged.emit(false);
  }
  setLoggedIn(logged: boolean): void {
    if (logged === true) {
      this.storage.setItem('loggedIn', '1');
      this.userLogged.emit(true);
    } else {
      this.storage.setItem('loggedIn', '0');
      this.userLogged.emit(false);
    }
  }
  getLoggedIn(): boolean {
    const logged = this.storage.getItem('loggedIn');
    if (logged === '1') {
      return true;
    } else {
      return false;
    }
  }

  setAccessToken(token: string): void {
    this.storage.setItem('accessToken', token);
  }
  getAccessToken(): any {
    return this.storage.getItem('accessToken');
  }
  setRefreshToken(token: string): void {
    this.storage.setItem('refreshToken', token);
  }
  getRefreshToken(): any {
    return this.storage.getItem('refreshToken');
  } 

  setExpirtytime(expiry: string): void {
    this.storage.setItem('tokenExpiry', expiry);
  }
  getExpiryTime(): any {
    return this.storage.getItem('tokenExpiry');
  } 

  
  setFirstName(firstName: string): void {
    this.storage.setItem('firstName', firstName);
  }
  getFirstName(): any {
    return this.storage.getItem('firstName');
  }

  setLastName(lastName: string): void {
    this.storage.setItem('lastName', lastName);
  }
  getLastName(): any {
    return this.storage.getItem('lastName');
  } 
  setAccountId(accountid: string): void {
    this.storage.setItem('accountId', accountid);
  }
  getAccountId(): any {
    return this.storage.getItem('accountId');
  }


  setUsertype(usertype: string): void {
    this.storage.setItem('userType', usertype);
  }
  getUsertype(): any {
    return this.storage.getItem('userType');
  }
  setIsAdmin(isadmin: boolean): void {
    if (isadmin === true) {
      this.storage.setItem('isAdmin', '1');
    } else {
      this.storage.setItem('isAdmin', '0');
    }
  }
  
  getIsAdmin(): any {
    const isAdmin = this.storage.getItem('isAdmin');
    if (isAdmin === '1') {
      return true;
    } else {
      return false;
    }
  }



}
